<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.productionInform") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <!-- <li class="breadcrumb-item">
                        <router-link to="/prd"><span>{{$t('tlt.prd')}}</span></router-link>
                    </li> -->
                    <li class="breadcrumb-item">
                        <router-link to="/prd/productionInform"><span>{{$t('tlt.productionInform')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('productionInform')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show " aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form class="row">
                                <!-- <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.productionInform.code") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="codeFilter" />
                                </div> -->
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.startDay") }} :
                                    </label>
                                    <mmf-datepicker  v-model="startDayFilter"></mmf-datepicker >

                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.endDay") }} :
                                    </label>
                                    <mmf-datepicker  v-model="endDayFilter"></mmf-datepicker >
                                </div>

                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.productionInform.title") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="titleFilter" />
                                </div>

                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.productionInform.editor") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="editorFilter" />
                                </div>

                                <div class="col-lg-4 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFClearFilter('productionInform')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>

                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('productionInform')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--显示列表-->
            <div id="productionInformListTable" class="content">
                <div class="card my-1">
                    <div
                            id="collapseTwo"
                            class="collapse show"
                            aria-labelledby="headingTwo"
                            data-parent="#accordionResult"
                    >
                        <div class="card-body">
                            <div class="bs-component">
                            </div>
                            <mmf-table id="test" entity="productionInform" inline-actions-disabled :singleChoice='true'>
                                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                                    <button
                                            :disabled = "slotProps.checkedLength !=1"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-on:click="MMFDisplay('productionInform')"
                                    >
                                        <i class="fa fa-cog" aria-hidden="true"></i>
                                        <span class="text">{{ $t("btn.productionInform.display") }}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {
        mapState,
        mapActions
    } from "vuex";
    import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        gridFields,
        filterFields
    } from "@/model/prd/productionInform/ProductionInform";
    import MmfTable from "@/components/MmfTable";
    import MmfDatepicker from "@/components/MmfDatepicker";

    // create a helper to generate getters and setters with namespace
    const {
        mapFields
    } = createHelpers({
        getterType: 'productionInform/getField',
        mutationType: 'productionInform/updateField',
    });

    export default {
        components: {MmfTable,MmfDatepicker},
        data() {
            return {
            }
        },
        name: "ProductionInformList",
        computed: {
            // generate and add getters and setters using the filter names defined in
            // entity model
            ...mapFields(filterFields),
            //define the state of rows and fields of grid
            ...mapState({
                rows: state => state.productionInform.rows,
                checkedItems: state => state.productionInform.checkedItems,
                entity:state=>state.productionInform.entity,
                tableColumns: gridFields
            })
        },
        methods: {
            ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew",
                "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter","MMFDisplay"
            ])
        },
    };
</script>
